// Complete services data from updated pricing document
export const servicesData = [
  // Body Contouring Services
  {
    id: "electromagnetic-therapy",
    category: "Body Contouring",
    title: "Electro Magnetic Therapy Machine",
    icon: null,
    services: [
      {
        name: "30 minute session",
        price: "$40",
        description: "Non-invasive electromagnetic therapy to build muscle and reduce fat"
      },
      {
        name: "60 minute session", 
        price: "$70",
        description: "Extended electromagnetic therapy for maximum muscle activation and toning"
      }
    ]
  },
  {
    id: "cryo-cavitation",
    category: "Body Contouring",
    title: "Cryo T-Shock OR Cavitation with Radio Frequency",
    icon: null,
    services: [
      {
        name: "30 minute session",
        price: "$50",
        description: "Choose between Cryo T-Shock for fat freezing or Cavitation with RF for body contouring"
      },
      {
        name: "45 minute session",
        price: "$70",
        description: "Extended session for enhanced fat reduction and skin tightening results"
      }
    ]
  },
  {
    id: "combination-therapy",
    category: "Body Contouring",
    title: "Combination Therapy",
    description: "Cryo T-Shock OR Cavitation with RF followed by electromagnetic therapy machine",
    icon: null,
    services: [
      {
        name: "30 min handheld + 30 min electromagnetic",
        price: "$75",
        description: "Combined treatment for optimal fat reduction and muscle toning"
      },
      {
        name: "30 min handheld + 60 min electromagnetic",
        price: "$100",
        description: "Extended combination therapy for maximum body transformation results"
      }
    ]
  },
  {
    id: "microneedling",
    category: "Body Contouring",
    title: "Microneedling",
    icon: null,
    services: [
      {
        name: "Per area",
        price: "$100",
        description: "Minimally invasive procedure to stimulate collagen production and improve skin texture"
      },
      {
        name: "Specialty Serums",
        price: "Contact for pricing",
        description: "Additional charge for any specialty serums. Please contact us for pricing."
      }
    ]
  },
  {
    id: "fibroblast",
    category: "Body Contouring",
    title: "Fibroblast",
    icon: null,
    services: [
      {
        name: "Under or upper eye",
        price: "$150",
        description: "Plasma pen treatment for skin tightening around the delicate eye area"
      },
      {
        name: "Smoker lines above lips",
        price: "$125",
        description: "Targeted treatment to reduce fine lines and wrinkles above the lips"
      }
    ]
  },
  {
    id: "body-analyzer",
    category: "Body Contouring",
    title: "Body Analyzer Machine",
    icon: null,
    services: [
      {
        name: "Single use",
        price: "$15",
        description: "Comprehensive body composition analysis including BMI, muscle mass, and body fat percentage"
      },
      {
        name: "Free with purchase",
        price: "FREE",
        description: "Complimentary body analysis with any treatment purchase"
      }
    ]
  },
  {
    id: "lymphatic-drainage",
    category: "Body Contouring",
    title: "Lymphatic Drainage",
    icon: null,
    services: [
      {
        name: "30 minute session",
        price: "$35",
        description: "Gentle massage technique to stimulate lymphatic system and reduce fluid retention"
      },
      {
        name: "60 minute session",
        price: "$50",
        description: "Extended lymphatic drainage session for enhanced detoxification and circulation"
      }
    ]
  },
  
  // Laser Hair Removal Services
  {
    id: "laser-hair-removal",
    category: "Laser Hair Removal",
    title: "Laser Hair Removal",
    description: "Professional laser hair removal - price per treatment",
    icon: null,
    services: [
      {
        name: "Under arms",
        price: "$35",
        description: "Quick and effective underarm hair removal"
      },
      {
        name: "Upper lip",
        price: "$15",
        description: "Precise upper lip hair removal"
      },
      {
        name: "Lower face",
        price: "$25",
        description: "Chin and lower face area treatment"
      },
      {
        name: "Lower leg",
        price: "$65",
        description: "Knee to ankle hair removal"
      },
      {
        name: "Full leg",
        price: "$125",
        description: "Complete leg hair removal from thigh to ankle"
      },
      {
        name: "Bikini area",
        price: "$85",
        description: "Bikini line hair removal"
      },
      {
        name: "Arms",
        price: "$65",
        description: "Full arm hair removal"
      },
      {
        name: "Chest",
        price: "$75",
        description: "Complete chest hair removal"
      },
      {
        name: "Full Back",
        price: "$100",
        description: "Entire back hair removal"
      },
      {
        name: "Upper back",
        price: "$50",
        description: "Upper back and shoulder area"
      }
    ]
  },
  
  // Skin Care Services
  {
    id: "skin-analyzer",
    category: "Skin Care",
    title: "Skin Analyzer",
    icon: null,
    services: [
      {
        name: "Single session",
        price: "$15",
        description: "Advanced skin analysis to identify concerns and create personalized treatment plans"
      },
      {
        name: "Included with 3 facials",
        price: "FREE",
        description: "Complimentary when purchasing a package of 3 facials"
      }
    ]
  },
  {
    id: "customized-facials",
    category: "Skin Care",
    title: "Customized Facials",
    description: "Types include firming peptide, oxygen, hydra and much more",
    icon: null,
    services: [
      {
        name: "90 minute facial",
        price: "$129",
        description: "Luxurious spa experience with deep cleansing, exfoliation, extraction, mask, and massage"
      },
      {
        name: "60 minute facial",
        price: "$99",
        description: "Complete facial treatment customized to your skin's specific needs"
      },
      {
        name: "Add dermaplaning",
        price: "+$40",
        description: "Add gentle exfoliation to remove dead skin cells and peach fuzz to any facial"
      }
    ]
  },
  {
    id: "back-facials",
    category: "Skin Care",
    title: "Back Facials",
    icon: null,
    services: [
      {
        name: "Back facial treatment",
        price: "Starts at $115",
        description: "Deep cleansing treatment for the back area, perfect for acne and congestion"
      }
    ]
  },
  {
    id: "chemical-peels",
    category: "Skin Care",
    title: "Chemical Peels",
    icon: null,
    services: [
      {
        name: "Face treatment - Including post care kit",
        price: "Starts at $175",
        description: "Professional-grade gel based and ethanol peels for facial skin renewal, includes aftercare products"
      },
      {
        name: "Other body parts",
        price: "Contact for pricing",
        description: "Chemical peels available on other body parts. Please contact us for pricing and consultation."
      }
    ]
  },
  {
    id: "switch-facial-treatment",
    category: "Skin Care",
    title: 'Switch Facial Treatment',
    icon: null,
    services: [
      {
        name: "Per treatment",
        price: "$175",
        description: "A unique alternative to a chemical peel activating the body's own natural repair system to reduce fine lines and improve skin texture and tone. Included with this service is a 2 week follow up with an enzyme treatment."
      }
    ]
  },
  {
    id: "rezenerate-nanofacial",
    category: "Skin Care",
    title: "Rezenerate Nanofacial",
    icon: null,
    services: [
      {
        name: "Per treatment with Vitamin C",
        price: "$129",
        description: "A painless treatment that stimulates collagen production by penetrating active ingredients into the deeper layers of the skin through superficial nano-infusion to reduce fine lines, signs of aging, sunspots, blemishes, uneven skin tone and texture."
      },
      {
        name: "Add Lips",
        price: "+$10",
        description: "Add lip treatment to your Rezenerate Nanofacial"
      },
      {
        name: "Add Neck",
        price: "+$25",
        description: "Add neck treatment to your Rezenerate Nanofacial"
      },
      {
        name: "Specialty Serums",
        price: "Contact for pricing",
        description: "Additional cost for any specialty serums used"
      }
    ]
  },
  {
    id: "pico-laser-treatment",
    category: "Skin Care",
    title: "Pico Laser Treatment",
    icon: null,
    services: [
      {
        name: "Per session",
        price: "Starts at $200",
        description: "A non surgical, non invasive skin rejuvenation procedure utilizing ultra short pulses of laser energy to address various skin concerns. Prices vary upon location."
      }
    ]
  },
  {
    id: "carboxy-laser",
    category: "Skin Care",
    title: "Carboxy Black Doll Laser Treatment",
    icon: null,
    services: [
      {
        name: "Per treatment",
        price: "$125",
        description: "Advanced carbon laser treatment for deep pore cleansing and skin rejuvenation"
      }
    ]
  },

  // Back Treatments
  {
    id: "back-cupping",
    category: "Back Treatments",
    title: "Back Cupping",
    icon: null,
    services: [
      {
        name: "Per session",
        price: "$25",
        description: "Traditional cupping therapy to relieve muscle tension and improve circulation"
      }
    ]
  }
];

// Popular services for homepage
export const popularServices = [
  {
    id: "laser-hair-removal",
    name: "Laser Hair Removal",
    category: "Laser Hair Removal",
    image: "/laser-hair-removal.jpeg",
    description: "Professional laser hair removal for long-lasting results"
  },
  {
    id: "microneedling",
    name: "Microneedling",
    category: "Body Contouring",
    image: "/micro-needling.jpg",
    description: "Treatment to improve skin texture and appearance"
  },
  {
    id: "cryo-cavitation",
    name: "Cryo T-Shock",
    category: "Body Contouring",
    image: "/cryo-t-shock.jpg",
    description: "Non-invasive body contouring treatment option"
  }
];

// Service categories for navigation
export const serviceCategories = [
  "Body Contouring",
  "Laser Hair Removal",
  "Skin Care",
  "Back Treatments"
];

// Helper function to get service by ID
export const getServiceById = (serviceId) => {
  return servicesData.find(service => service.id === serviceId);
};

// Helper function to get all services in a category
export const getServicesByCategory = (category) => {
  return servicesData.filter(service => service.category === category);
};